import styled from 'styled-components/macro';
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useToast,
} from "@chakra-ui/react";
import {useUnban} from "../../../api/moderation";
import {useFeedback} from "../../../store/feedback";
import {useState} from "react";

const UnbanUser = styled(({className, community, onClose}) => {
    const {feedbackCh} = useFeedback();
    const unban = useUnban(feedbackCh);
    const toast = useToast();
    const [username, setUsername] = useState('');
    const handleUnban = async () => {
        await unban(username, community);
        toast({
            title: `Successfully unbanned!`,
            status: 'success',
            isClosable: true,
        });
        onClose();
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Unban</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <FormControl>
                        <FormLabel>Username</FormLabel>
                        <Input
                            value={username}
                            onChange={(e) => setUsername(e.currentTarget.value)}
                            maxLength="64"
                            autoComplete="off"
                            type="text"
                            required
                            mb={'10px'}
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>
                        Close
                    </Button>
                    <Button variant="blue" onClick={handleUnban}>
                        Unban
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
})`
`;

export default UnbanUser;
